<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Create Ticket</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-form ref="form" v-model="frmValid" enctype="multipart/form-data">
        <v-container grid-list-lg class="pa-4">
          <v-layout row wrap>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-4">
              Category
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-select
                v-model="cboCategoryId"
                :items="categories"
                item-text="name"
                item-value="ticketCategoryId"
                :rules="[v => !!v || 'Please select category']"
                label=""
                @change="clickCategory($event)"
                required
              ></v-select>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-4">
              Order No
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-text-field
                v-model="txtSalesOrderNo"
                :rules="(isRequireSalesOrderNo ? [v => !!v || 'Sales Order No is required'] : [])"
                label=""
                :required="isRequireSalesOrderNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-4">
              Title
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-text-field
                v-model="txtTitle"
                label=""
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-2">
              Buyer
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-chip v-for="buyer in cboBuyers" :key="buyer.userId" close @input="removeBuyer(buyer)">{{ buyer.loginEmail }}</v-chip>
              <v-btn
                outline
                icon
                small
                v-if="cboBuyers.length < 1"
                class="ml-2 mr-0 mt-0 mb-0"
                @click="showAddBuyerDialog"
              >
                <v-icon small>add</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-4">
              Admins
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-combobox
                v-model="cboAdmins"
                :items="admins"
                item-text="name"
                item-value="adminId"
                label=""
                hide-details
                chips
                :rules="[v => !!v || 'Please select admin']"
                multiple
                required
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeAdmin(data.item)"
                  >
                    <v-avatar v-if="data.item.isPrimaryHandler === 1">
                      <v-icon color="orange">account_circle</v-icon>
                    </v-avatar>
                    <strong>{{ data.item.name }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-4">
              Sellers
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-combobox
                v-model="cboSellers"
                :items="sellers"
                item-text="storeName"
                item-value="storeId"
                label=""
                hide-details
                chips
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeSeller(data.item)"
                  >
                    <strong>{{ data.item.storeName }} ({{ data.item.storeType }})</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs3 sm2 md2 lg1 class="font-weight-bold pt-3">
              Emails
            </v-flex>
            <v-flex xs9 sm10 md10 lg11>
              <v-chip v-for="email in cboEmails" :key="email" close @input="removeEmail(email)">{{ email }}</v-chip>
              <v-btn
                outline
                icon
                small
                class="ml-2 mr-0 mt-0 mb-0"
                @click="showAddEmailDialog"
              >
                <v-icon small>add</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <trumbowyg id="trumbowyg" v-model="txtMessage" :config="trumbowygConfig"></trumbowyg>
              <!--<v-textarea
                outline
                v-model="txtMessage"
                label="Your message"
                :rules="[v => !!v || 'Message is required']"
                class="mt-4"
                required
              ></v-textarea>-->
            </v-flex>
            <v-flex xs12 sm6>
              <v-switch
                v-model="switchPrivateMessageForAdmin"
                color="primary"
                label="Private message for admin"
                hide-details
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm6>
              <v-switch
                v-model="switchPrivateMessageForSeller"
                color="primary"
                label="Private message for seller"
                hide-details
              ></v-switch>
            </v-flex>
            <v-flex xs12 class="mt-4">
              <div class="font-weight-bold">UPLOADED FILES</div>
              <v-list v-if="fileUploads.length > 0" style="background-color:transparent;">
                <template v-for="(file, fileIndex) in fileUploads">
                  <v-list-tile
                    :key="fileIndex"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="body-2">
                        {{ file.name }}
                        <v-btn
                          icon
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          @click="removeFileUpload(fileIndex)"
                        >
                          <v-icon small>close</v-icon>
                        </v-btn>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'success'" class="green--text ml-3">
                          <v-icon small color="green" class="mr-1">done</v-icon>
                          Uploaded
                        </span>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'uploading'" class="orange--text ml-3">
                          <v-icon small color="orange" class="mr-1">hourglass_empty</v-icon>
                          Uploading
                        </span>
                        <span v-if="file.uploadStatus && file.uploadStatus === 'error'" class="red--text ml-3">
                          <v-icon small color="red" class="mr-1">close</v-icon>
                          Upload failed
                        </span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
              <input
                type="file"
                multiple
                style="display: none"
                ref="filePicker"
                accept="*"
                @change="onFilePicked"
                @click="$refs.filePicker.value = null"
              >
              <div>
                <span v-if="fileUploads.length === 0" class="grey--text">No file uploaded</span>
                <v-btn
                  outline
                  small
                  v-if="fileUploads.length < 3"
                  @click="pickFile"
                >
                  Add file
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-btn
                block
                large
                class="mt-4"
                color="primary"
                :disabled="!frmValid"
                @click="submit"
              >
                Send Message
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-dialog v-model="dialogAddBuyer" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Buyer</v-card-title>
          <v-card-text>
            <v-form ref="frmAddBuyer" v-model="frmAddBuyerValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddBuyerUserId"
                :rules="[v => !!v || 'Buyer is required']"
                label="Buyer Id / Email"
                required
                @keyup.enter="addBuyer(txtAddBuyerUserId)"
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddBuyerValid"
                @click="addBuyer(txtAddBuyerUserId)"
              >
                Add Buyer
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddEmail" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Email</v-card-title>
          <v-card-text>
            <v-form ref="frmAddEmail" v-model="frmAddEmailValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddEmail"
                :rules="[v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Invalid email format']"
                label="Email"
                @keyup.enter="addEmail"
                required
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddEmailValid"
                @click="addEmail"
              >
                Add Email
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>

form >>> div.trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
  z-index: 1;
}

form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'

let $ = window.$

export default {
  components: {
    SideDrawer,
    Loading,
    Trumbowyg
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      admins: [],
      sellers: [],
      categories: [],
      frmValid: true,
      txtTitle: '',
      isRequireSalesOrderNo: false,
      txtSalesOrderNo: this.$route.query.order || '',
      cboCategoryId: '',
      cboBuyers: [],
      cboAdmins: [],
      cboSellers: [],
      cboEmails: [],
      txtMessage: '',
      switchPrivateMessageForAdmin: false,
      switchPrivateMessageForSeller: false,
      fileUploads: [],
      dialogAddBuyer: false,
      frmAddBuyerValid: false,
      txtAddBuyerUserId: '',
      dialogAddEmail: false,
      frmAddEmailValid: false,
      txtAddEmail: '',
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btns: [
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['removeformat'],
          ['upload']
        ],
        plugins: {
          upload: {
            serverPath: process.env.VUE_APP_API_ROOT + '/v1/ticket/wysiwyg/image',
            fileFieldName: 'image',
            headers: {
              'Authorization': axios.defaults.headers.common['Authorization'],
              'X-API-KEY': axios.defaults.headers.common['X-API-KEY']
            },
            urlPropertyName: 'url'
          },
          resizimg: {
            minSize: 64
          }
        }
      }
    }
  },

  mounted () {
    console.log($)
    this.openDrawerForDesktop()
    this.getAdmins()
    this.getSellers()
    this.getCategories()

    var _this = this
    if (_this.$route.query.buyer) {
      setTimeout(function () {
        _this.addBuyer(_this.$route.query.buyer)
      }, (0.5 * 1000))
    }
  },

  methods: {
    clickCategory: function (categoryId) {
      var isRequireSalesOrderNo = false
      for (var i in this.categories) {
        if (this.categories[i].ticketCategoryId === categoryId) {
          if (this.categories[i].isRequireSalesOrderNo === '1') {
            isRequireSalesOrderNo = true
          } else {
            isRequireSalesOrderNo = false
          }
          break
        }
      }
      this.isRequireSalesOrderNo = isRequireSalesOrderNo
    },
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.fileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.fileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.fileUploads.splice(fileIndex, 1)
    },
    showAddBuyerDialog: function () {
      this.frmAddBuyerValid = false
      this.txtAddBuyerUserId = ''
      this.dialogAddBuyer = true
    },
    addBuyer: function (buyerUserId) {
      if (buyerUserId.length > 0) {
        var _this = this
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + buyerUserId)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              this.cboBuyers.push(resp.data.data)
              this.dialogAddBuyer = false
            } else {
              window.alert('Unable to load buyer ' + buyerUserId + ': ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(this)
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
            }
          })
      } else {
        window.alert('Buyer required')
      }
    },
    removeBuyer: function (item) {
      var _this = this
      _this.cboBuyers.splice(_this.cboBuyers.indexOf(item), 1)
      _this.cboBuyers = [..._this.cboBuyers]
    },
    getAdmins: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/admins')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.admins = resp.data.data
            if (_this.cboAdmins.length === 0) {
              _this.cboAdmins.push(_this.profile)
            }
          } else {
            console.log('unable to load admin list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    removeAdmin: function (item) {
      this.cboAdmins.splice(this.cboAdmins.indexOf(item), 1)
      this.cboAdmins = [...this.cboAdmins]
    },
    getSellers: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,branch,franchise')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.sellers = resp.data.data
          } else {
            console.log('unable to load seller list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    removeSeller: function (item) {
      this.cboSellers.splice(this.cboSellers.indexOf(item), 1)
      this.cboSellers = [...this.cboSellers]
    },
    showAddEmailDialog: function () {
      this.frmAddEmailValid = false
      this.txtAddEmail = ''
      this.dialogAddEmail = true
    },
    addEmail () {
      if (this.$refs.frmAddEmail.validate()) {
        this.cboEmails.push(this.txtAddEmail)
        this.dialogAddEmail = false
      }
    },
    removeEmail: function (item) {
      var _this = this
      _this.cboEmails.splice(_this.cboEmails.indexOf(item), 1)
      _this.cboEmails = [..._this.cboEmails]
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    getCategories: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/ticket/categories')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            var categories = []
            _this.categories = this.generateCategoryListRecursive(resp.data.data, categories, 0)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    submit: function () {
      var _this = this
      if (_this.$refs.form.validate()) {
        if (_this.cboAdmins.length > 0) {
          if (_this.cboBuyers.length > 0 || _this.cboSellers.length > 0 || _this.cboEmails.length > 0) {
            _this.loading = true

            // inject files
            var i, j
            var isUploadFile = false
            var formData = new FormData()
            for (i in _this.fileUploads) {
              if (typeof _this.fileUploads[i].uploadStatus === 'undefined' || _this.fileUploads[i].uploadStatus !== 'success') {
                formData.append('file' + (parseInt(i) + 1), _this.fileUploads[i].file, _this.fileUploads[i].name)
                _this.fileUploads[i].uploadStatus = 'uploading'
                isUploadFile = true
              }
            }

            if (isUploadFile) {
              // upload files
              axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/file', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
                .then(resp => {
                  console.log(resp.data)
                  if (resp.data.status === 'success') {
                    var errorCount = 0
                    for (i = 1; i <= 3; i++) {
                      if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].ticketFileId !== 'undefined') {
                        for (j in _this.fileUploads) {
                          if (resp.data.data['file' + i].fileName === _this.fileUploads[j].name) {
                            if (typeof resp.data.data['file' + i].ticketFileId !== 'undefined') {
                              _this.fileUploads[j].ticketFileId = resp.data.data['file' + i].ticketFileId
                              _this.fileUploads[j].uploadStatus = 'success'
                            } else {
                              _this.fileUploads[j].uploadStatus = 'error'
                              errorCount++
                            }
                            break
                          }
                        }
                      }
                    }

                    // only continue if all upload success
                    if (errorCount === 0) {
                      _this.submitTicket()
                    } else {
                      window.alert(errorCount + ' of the file upload failed, please retry')
                    }
                  } else {
                    window.alert(resp.data.message)
                  }
                  _this.loading = false
                })
                .catch(function (error) {
                  if (error.response) {
                    console.log(error.response.status)
                    if (error.response.status === 401) {
                      router.push('/login?next=' + _this.$route.fullPath)
                    } else if (error.response.status === 403) {
                      _this.showAlert(error)
                    }
                    _this.loading = false
                  }
                })
            } else {
              _this.submitTicket()
            }
          } else {
            window.alert('Buyer, seller or email is required')
          }
        } else {
          window.alert('Admin is required')
        }
      }
    },
    submitTicket: function () {
      var _this = this
      if (_this.$refs.form.validate()) {
        if (_this.cboAdmins.length > 0) {
          if (_this.cboBuyers.length > 0 || _this.cboSellers.length > 0 || _this.cboEmails.length > 0) {
            _this.loading = true
            var i
            var submitData = {
              ticketCategoryId: _this.cboCategoryId,
              salesOrderNo: _this.txtSalesOrderNo,
              title: _this.txtTitle,
              message: _this.txtMessage,
              isPrivateMessageForAdmin: _this.switchPrivateMessageForAdmin,
              isPrivateMessageForSeller: _this.switchPrivateMessageForSeller
            }

            // inject files
            if (_this.fileUploads.length > 0) {
              var fileIds = []
              for (i in _this.fileUploads) {
                fileIds.push(_this.fileUploads[i].ticketFileId)
              }
              submitData.fileIds = fileIds
            }

            // inject admins
            if (_this.cboAdmins.length > 0) {
              var admins = []
              for (i in _this.cboAdmins) {
                admins.push({
                  adminId: _this.cboAdmins[i].adminId
                })
              }
              submitData.admins = admins
            }

            // inject buyer
            if (_this.cboBuyers.length > 0) {
              submitData.userId = _this.cboBuyers[0].userId
            }

            // inject sellers
            if (_this.cboSellers.length > 0) {
              var sellers = []
              for (i in _this.cboSellers) {
                sellers.push({
                  userId: _this.cboSellers[i].userId
                })
              }
              submitData.sellerUserIds = sellers
            }

            // inject emails
            if (_this.cboEmails.length > 0) {
              submitData.emails = _this.cboEmails
            }

            // create ticket
            axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket', submitData, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                _this.loading = false
                console.log(resp.data)
                if (resp.data.status === 'success') {
                  router.push('/ticket/' + resp.data.data.ticketId)
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + _this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    _this.showAlert(error)
                  }
                  _this.loading = false
                }
              })
          } else {
            window.alert('Buyer, seller or email is required')
          }
        } else {
          window.alert('Admin is required')
        }
      }
    }
  }
}
</script>
